/// <reference types="@types/googlemaps" />
import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MapLoaderService } from '../../../core/services/maploader.service';

@Component({
  selector: 'app-auto-complete',
  template: `
  <div style="display:flex;width:100%;height:48px;line-height:48px;border: 1px solid #DEDEDE;
  border-radius: 5px;">
  <img src="./assets/images/black/search.png" style="width:20px;height: 20px;margin:14px;">
  <input type="text"
  placeholder="Search a location"
  [(ngModel)]="autocompleteInput"
  #addresstext
  style={{style}}
  ngStyle.lt-sm="width: calc(100% - 50px);"
  required>
</div>
  `

  // <input
  // class="input"
  // type="text"
  // placeholder="Search a location"
  // [(ngModel)]="autocompleteInput"
  // #addresstext
  // style={{style}}
  // ngStyle.lt-sm="width: calc(100% - 50px)"
  // required
  //   />
})
export class AutocompleteComponent implements OnInit, AfterViewInit {
  @Input() style: string;
  @Input() addressType: string;
  @Output() setAddress: EventEmitter<any> = new EventEmitter();
  @ViewChild('addresstext', { static: true }) addresstext: any;

  autocompleteInput: string;
  queryWait: boolean;
  specifiedstyle: string;

  constructor(private mapLoaderService: MapLoaderService) {
    this.specifiedstyle = this.style;
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.mapLoaderService.initMap('en').then(() => {
      this.getPlaceAutocomplete();
    });
  }

  clear() {
    this.autocompleteInput = '';
  }

  private getPlaceAutocomplete() {
    const autocomplete = new google.maps.places.Autocomplete(this.addresstext.nativeElement, {
      // componentRestrictions: {country: ['AU']},
      types: [this.addressType] // 'establishment' / 'address' / 'geocode'
    });
    google.maps.event.addListener(autocomplete, 'place_changed', () => {
      const place = autocomplete.getPlace();
      console.log(place);
      this.invokeEvent(place);
    });
  }

  invokeEvent(place: object) {
    this.setAddress.emit(place);
  }
}
